import { ApproverJurisdictionInfoDTO } from "../../services/contactReportsApi";

export const areJurisdictionsEqual = (first: ApproverJurisdictionInfoDTO, second: ApproverJurisdictionInfoDTO): boolean =>
  (first.location?.id ?? -1) === (second.location?.id ?? -1) && (first.organisation?.id ?? -1) === (second.organisation?.id ?? -1);
